import React from 'react';
import {StyleSheet, SafeAreaView} from 'react-native';
import ModuleDetails from './ModuleDetails';
import {appBackground} from '../../utils/utils';
import {useRoute} from '@react-navigation/core';
import {useNavigation} from '@react-navigation/native';
export const ModulesContainer = props => {
   const navigation = useNavigation();
   return (
      <SafeAreaView style={styles.container}>
         <ModuleDetails
            onRowSelected={id => {
               //Navigate to Module details
               //props.navigation.navigate('ModuleDetails');
            }}
            navigation={navigation}
         />
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: appBackground,
   },
});
